import { RoutingLink } from "#src/batteries-included-components/RoutingLink";
import { UserGroupDetailsRoutePath } from "#src/routes/settings/users/groups/[groupId]/details";
import {
  Chip,
  Icon,
  type DataDisplayProps,
} from "@validereinc/common-components";
import type { UserGroupType } from "@validereinc/domain";
import React from "react";

export type UserGroupDataDisplayProps = Pick<UserGroupType, "name" | "id"> &
  Pick<DataDisplayProps, "isLoading" | "isBusy" | "isInline" | "alignment"> & {
    sizeVariant?: "small" | "medium";
  };

export const UserGroupDataDisplay = ({
  id,
  name,
  sizeVariant = "medium",
  alignment = "left",
  isInline,
  isLoading,
  isBusy,
}: UserGroupDataDisplayProps) => {
  return (
    <div
      aria-label="User Group details"
      style={{
        display: isInline ? "inline-flex" : "flex",
        alignItems: "baseline",
        justifyContent:
          alignment === "justified"
            ? "center"
            : alignment === "right"
              ? "flex-end"
              : "flex-start",
      }}
    >
      <RoutingLink
        to={UserGroupDetailsRoutePath.toLink({
          pathParams: { groupId: id },
        })}
        variant={isInline ? "secondary" : "primary"}
      >
        {!isInline ? (
          <Chip
            text={name}
            style={{
              marginRight: 4,
              height: sizeVariant === "medium" ? 24 : 18,
            }}
            shapeVariant="rounded"
            slotLeft={() => (
              <Icon
                variant="users-three"
                size={sizeVariant === "medium" ? 18 : 12}
              />
            )}
            isLoading={isLoading}
            isBusy={isBusy}
          />
        ) : (
          name
        )}
      </RoutingLink>
    </div>
  );
};
